import { authState, userState } from "atoms/auth";
import DarkModeToggler from "components/Layout/DarkModeToggler";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { appStrings } from "utils/appStrings";

export interface AuthPaneProps {}

const AuthPane: React.FC<AuthPaneProps> = () => {
  const history = useHistory();
  const [path, setPath] = useState<string>(window.location.href);

  useEffect(() => {
    return history.listen((location) => {
      setPath(window.location.href);
    });
  }, [history]);
  const auth = useRecoilValue(authState);
  const user = useRecoilValue(userState);

  if (auth && user) {
    return (
      <div className="flex flex-row items-center">
        <a href={process.env.REACT_APP_PROFILE_URL} className="ml-2">
          <img
            src={`/assets/img/avatar.png`}
            className="w-8 h-8 rounded-full"
            alt="user-avatar"
          />
        </a>
        <DarkModeToggler />
      </div>
    );
  }

  return (
    <div className="flex flex-row items-center">
      <a
        href={`${process.env.REACT_APP_AUTH_URL}?from=${encodeURIComponent(
          path
        )}`}
        className="ml-2 text-sm text-primary-800"
      >
        {appStrings.auth}
      </a>
      <DarkModeToggler />
    </div>
  );
};

export default AuthPane;
